import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { IconModule, StarRatingModule } from '@spartacus/storefront';
import { CustomTrustedShopsWidgetModule } from 'src/app/custom/cms-components/trustedshops/custom-truestedshops-widget/custom-trustedshops-widget.module';
import { CustomProductTagsModule } from '../custom-product-tags/custom-product-tags.module';
import { CustomProductIntroComponent } from './custom-product-intro.component';

@NgModule({
  declarations: [CustomProductIntroComponent],
  imports: [
    CommonModule,
    I18nModule,
    StarRatingModule,
    IconModule,
    CustomProductTagsModule,
    CustomTrustedShopsWidgetModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductIntroComponent: {
          component: CustomProductIntroComponent,
        },
      },
    }),
  ],
})
export class CustomProductIntroModule {}
